/**
* @description
* # name controller --> levelsListController
* # As Controller --> levelsLst
* brief comment controller shows the view for the main page of assignTimeRange
*/

export default class levelsListController {
	constructor($scope,levelsServices,ngNotify,UserInfoConstant,$state,$filter,) {
		var vm = this;
		this.$scope = $scope;
		this.ngNotify = ngNotify;
		this.$state = $state;
		this.services   = levelsServices.services;
		this.buttonActions = true
		this.$scope.grid = false;
		this.$scope.edit = true;
		this.$scope.titleList = true;
		this.$translate = $filter('translate')
		this.conceptId = 0
		

		$scope.UserInfoConstant = UserInfoConstant;
		$scope.$watch('UserInfoConstant[0].details[0]', (details) => {
			if (details !== undefined) {
				vm.user = details.user.id;
				vm.USER_ID = details.user.id;
				this.conceptId = details.user.conceptId
				vm.init()
			}
		});

	}

	init(){
		this.services.getLevels({ concept_id: this.conceptId}).$promise.then((dataReturn) => {
			if(dataReturn.results.lenght == 0){
				this.ngNotify.set('no existen registros','warn')
			}else{
				this.levels = []
				this.levelList = dataReturn.results;
				for (let i in this.levelList){
					this.levels.push({
						title: this.levelList[i].ds_name,
						id_code: this.levelList[i].id_code,
						cod: "Código: " + this.levelList[i].id_code,
						badges: [
							{
								label: ( (this.levelList[i].is_active === true) ? this.$translate('ACTIVE') : this.$translate('INACTIVE')),
								bg: ( (this.levelList[i].is_active === true) ? "bg-success" : "bg-dark" ),
								icon: "mdi-check"
							}
						]
					})
				}
			}
		}, (err) => {
			this.ngNotify.set('No se ha podido conectar con el servicio','error');
		})
	}

	onClick(item){
		this.levelId=item.id_code;
		this.levelName=item.title;
		this.getDetailsFunction({level_id:this.levelId});
		this.panelConfig = true
		this.buttonActions = false
	}

	getDetailsFunction(params){
		this.services.getLevelDetails(params).$promise.then((dataReturn) => {
			if(dataReturn.results && Object.keys(dataReturn.results).length === 0){
				this.ngNotify.set('registro seleccionado no tiene registros','warn');

			}else{
				this.level = dataReturn.results;
				this.$scope.grid=true
			}
		}, (err) => {
			this.ngNotify.set('No se ha podido conectar con el servicio','error');
		})

	}

	edit(){
		this.$scope.editSave = true;
		this.$scope.edit = false;
		this.$scope.titleList = false;
		this.$scope.titleEdit = true;
		this.$scope.isDisabled = false;
	}

	cancelEdit(){
		this.$scope.editSave = false;
		this.$scope.edit = true;
		this.$scope.titleList = true;
		this.$scope.titleEdit = false;

		this.getDetailsFunction({level_id : this.levelId});
		
	}

	saveEdit(){
		const params = {
			level_id: this.levelId,
			name: this.levelName,
			user_id: this.USER_ID
		}

		this.services.updateLevels(params).$promise.then((dataReturn) => {
			if(dataReturn.status == 0){
				this.ngNotify.set('Se ha modificado de manera correcta el Nivel','success');
				this.$state.go(this.$state.current, {}, {reload: true});
				this.$scope.edit = true;
				this.$scope.editSave = false;
				this.$scope.titleList = true;
				this.$scope.titleEdit = false;

			}else{
				if (dataReturn.isUniqueViolation) {
					this.ngNotify.set('Nombre de nivel se repite','error');
				}
				this.$scope.isDisabled = false;
			}
		}, (err) => {
			if (err.data.isUniqueViolation) {
				this.ngNotify.set('Nombre de nivel ya existe','error');
			} else {
				this.ngNotify.set('No se ha podido conectar con el servicio','error');
			}
			this.$scope.isDisabled = false;
		})

	}

	toggleList(isHide) {
		this.$scope.toggle = isHide
	}
}
levelsListController.$inject=['$scope', 'levelsServices','ngNotify','UserInfoConstant','$state','$filter']


// WEBPACK FOOTER //
// ./src/app/admin-panel/levels/list/levelsListController.js